import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    QueryList,
    ViewChildren
} from '@angular/core';
import { AccordionBoxInterface } from './shared/interfaces/accordion-box.interface';
import { PathsService } from '@draeger-academy/common';

@Component({
    selector: 'da-accordion-box',
    templateUrl: './accordion-box.component.html',
    styleUrls: ['./accordion-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccordionBoxComponent implements OnInit {
    @Input() data: AccordionBoxInterface;
    @ViewChildren('accordion') accordion: QueryList<ElementRef>;
    requiredQualifications: {
        qualificationName: string;
        qualificationId: string;
        mediatingCourses: {
            id: string;
            name: string;
        }[];
    }[] = [];
    rqCourses: {
        id: string;
        name: string;
    }[] = [];

    public videoImageAspectRatios = [
        {
            breakpoint: 360,
            width: 480,
            height: 360,
            akamaiImage: null
        },
        {
            breakpoint: 480,
            width: 768,
            height: 576,
            akamaiImage: null
        },
        {
            breakpoint: 768,
            width: 480,
            height: 360,
            akamaiImage: null
        },
        {
            breakpoint: 1120,
            width: 578,
            height: 434,
            akamaiImage: null
        },
        {
            breakpoint: 1600,
            width: 600,
            height: 450,
            akamaiImage: null
        }
    ];

    getCourses(i: number) {
        const requiredQualifications = this.data.itemList[i].copytext.value;
        const rqCourses = requiredQualifications.flatMap((rq) => rq.mediatingCourses);
        return rqCourses;
    }
    constructor(
        protected _ref: ChangeDetectorRef,
        private _pathsService: PathsService
    ) {}

    @HostListener('window:resize', ['$event'])
    resizeBy($win) {
        if (this.accordion) {
            this.accordion.forEach((item, i) => {
                if (item.nativeElement.classList.contains('active')) {
                    item.nativeElement.nextSibling.style.maxHeight = null;
                    item.nativeElement.nextSibling.style.maxHeight = item.nativeElement.nextSibling.scrollHeight + 'px';
                }
            });
        }
    }

    ngOnInit() {
        if (this.data?.isRequiredQualification) {
            if (this.data?.isOpen) {
                setTimeout(() => {
                    this.toggle(0, null);
                }, 100);
            }
        }
    }

    toggle(index: number, headline: string) {
        if (this.accordion) {
            this.accordion.forEach((item, i) => {
                if (index === i) {
                    item.nativeElement.classList.toggle('active');
                    if (item.nativeElement.nextSibling.style.maxHeight) {
                        item.nativeElement.nextSibling.style.maxHeight = null;
                    } else {
                        item.nativeElement.nextSibling.style.maxHeight = item.nativeElement.nextSibling.scrollHeight + 'px';
                    }
                }
            });
        }
    }

    public goToQualificationDetail(id) {
        const _path: any = this._pathsService.getCourseDetailLink(id);
        window.location.href = _path;
    }

    public hasMedia(index: number) {
        const item = this.data.itemList.filter((x, i) => i === index);
        return item[0].image?.imageUrl || item[0].video?.imageUrl;
    }

    public isRequiredQualification() {
        return this.data.isRequiredQualification;
    }

    public getImageUrl(index: number) {
        const item = this.data.itemList.filter((x, i) => i === index);
        const _target = item[0].mediaType === 'image' ? item[0].image?.imageUrl : item[0].video?.imageUrl;
        return _target == null ? '' : _target;
    }

    public getClassByLinkType(imageUrl: string) {
        let iconClass = 'drg-icon-internal_link';
        // If the link starts with "http", it should be handled as external
        if (imageUrl) {
            if (imageUrl.indexOf('http') > -1) {
                iconClass = 'drg-icon-external_link';
            }
            // Does the URL includes something like .draeger.com? If yes, it should be handled as internal
            if (imageUrl.indexOf('.draeger.com') > -1) {
                iconClass = 'drg-icon-internal_link';
                if (imageUrl.indexOf('static.draeger.com') > -1) {
                    iconClass = 'drg-icon-external_link';
                }
            }

            if (imageUrl.indexOf('.pdf') > -1 || imageUrl.indexOf('.zip') > -1) {
                iconClass = 'drg-icon-download';
            }
        }
        return iconClass;
    }
}
